/**
 * mesh.js - Mesh-Erstellung und Verwaltung
 */
import * as THREE from "three";
import { scene } from "./scene.js";
import { settings, materialColor } from "./settings.js";
import { textures, currentTextureName } from "./textures.js";

// Aktuelles Mesh und Vertex-Daten
export let currentMesh = null;
export let positionClone = null;
export let normalClone = null;
export let countVertices = 0;

/**
 * Erstellt das Material
 */
function createMaterial() {
  return new THREE.MeshStandardMaterial({
    metalness: settings.metalness,
    roughness: settings.roughness,
    displacementScale: settings.displacementScale,
    color: materialColor,
  });
}

/**
 * Erstellt die Geometrie
 */
function createGeometry(type) {
  switch (type) {
    case "Sphere":
      return new THREE.SphereGeometry(settings.size, 100, 100);
    case "Donut":
      return new THREE.TorusGeometry(0.4, 0.2, 100, 100);
    default:
      return new THREE.TorusGeometry(0.4, 0.2, 100, 100);
  }
}

/**
 * Wendet Texturen auf das Mesh an
 */
function applyTextures(mesh, materialName) {
  if (!mesh || !mesh.material || !textures[materialName]) return;

  const tex = textures[materialName];
  const mat = mesh.material;

  if (tex.normalMap) mat.normalMap = tex.normalMap;
  if (tex.roughnessMap) mat.roughnessMap = tex.roughnessMap;
  if (tex.map) mat.map = tex.map;
  if (tex.aoMap) mat.aoMap = tex.aoMap;
  if (tex.metalnessMap) mat.metalnessMap = tex.metalnessMap;
  if (tex.emissiveMap) mat.emissiveMap = tex.emissiveMap;
  if (tex.displacementMap) mat.displacementMap = tex.displacementMap;

  mat.needsUpdate = true;
}

/**
 * Wechselt das 3D-Objekt
 */
export function switchObject(type) {
  // Altes Mesh entfernen
  if (currentMesh) {
    scene.remove(currentMesh);
    currentMesh.geometry.dispose();
    currentMesh.material.dispose();
  }

  // Neues Mesh erstellen
  const geometry = createGeometry(type);
  const material = createMaterial();
  currentMesh = new THREE.Mesh(geometry, material);
  currentMesh.scale.set(0.7, 0.7, 0.7);
  scene.add(currentMesh);

  // Vertex-Daten für Animationen klonen
  positionClone = JSON.parse(
    JSON.stringify(Array.from(geometry.attributes.position.array))
  );
  normalClone = JSON.parse(
    JSON.stringify(Array.from(geometry.attributes.normal.array))
  );
  countVertices = geometry.attributes.position.count;

  // Texturen anwenden
  applyTextures(currentMesh, currentTextureName);

  return currentMesh;
}

/**
 * Ändert die Mesh-Größe
 */
export function changeDonutSize(size) {
  if (currentMesh) {
    const s = parseFloat(size);
    currentMesh.scale.set(s, s, s);
  }
}

/**
 * Ändert die Mesh-Farbe
 */
export function changeDonutColor(colorCode) {
  if (currentMesh) {
    const hexColor = String(colorCode).replace(/^#/, "");
    const numericColor = parseInt(hexColor, 16);
    currentMesh.material.color.setHex(numericColor);
  }
}

/**
 * Setzt die Sichtbarkeit des Donuts
 * (Haare bleiben sichtbar wenn aktiviert)
 */
export function setDonutVisible(visible) {
  settings.donutVisible = visible;
  if (currentMesh) {
    currentMesh.visible = visible;
  }
}
